function onSdkReady() {
  const gw = window.gw;
  if (!gw) return;

  const moduleName = gw.sdk.common.constants.modules.CART;

  gw.sdk.runIfModuleReady(moduleName, () => {
    gw.sdk.cart.methods.setCustomCartRepository({
      async addToCart(params) {
        const shopifyBody = {
          items: params.items.map((item) => ({
            id: item.variantID,
            quantity: item.quantity ?? 1,
          })),
        };

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(shopifyBody),
        });

        const addData = await response.json();

        if (!response.ok) {
          throw new Error(addData.description || 'Failed to add to cart');
        }

        const cart = await fetch('/cart.js').then((r) => r.json());

        // Open the native cart drawer
        const cartDrawer = /** @type {{ open: () => void } | null} */ (document.querySelector('cart-drawer-component'));
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }

        // Trigger cart-items-component to re-render its content
        const cartUpdateEvent = new Event('cart:update', { bubbles: true });
        /** @type {any} */ (cartUpdateEvent).detail = { data: { sections: {} } };
        document.dispatchEvent(cartUpdateEvent);

        return { cart, sections: {} };
      },

      async getCart() {
        const cart = await fetch('/cart.js').then((r) => r.json());
        return { cart };
      },

      async updateCart(params) {
        const cart = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(params),
        }).then((r) => r.json());
        return { ...cart, sections: {} };
      },
    });
  });
}

if (window.gw && window.gw.sdk) {
  onSdkReady();
} else {
  document.addEventListener('gwSdkReady', onSdkReady);
}